import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import API_PATH from "~/utils/api-routes";
import api from "~/utils/Interceptor";

export type DZI_FILE_TYPE = {
  key: string;
  folder: string;
  dziPath: string;
  img: string;
  highImg?: string;
};
interface DhyanMurtiInitState {
  murtiList: Array<DZI_FILE_TYPE>;
  isLoading: boolean;
}

const initialState: DhyanMurtiInitState = {
  murtiList: [],
  isLoading: false,
};

export const getDhyanMurti = createAsyncThunk("dhyanMurti/getDhyanMurti", async () => {
  const response = await api.get(API_PATH.DHYAN_MURTI);
  return response.data.data;
});

export const dhyanMurtiSlice = createSlice({
  name: "dhyanMurti",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getDhyanMurti.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getDhyanMurti.fulfilled, (state, action) => {
      state.isLoading = false;
      state.murtiList = action.payload;
    });
    builder.addCase(getDhyanMurti.rejected, (state) => {
      state.isLoading = false;
    });
  },
});

export default dhyanMurtiSlice.reducer;
